import { ClientApplicationType } from "@/hooks/types";
import { InstallClientPage } from "@/pages";
import {
  deviceSlugSchema,
  installationTypeSchema,
} from "@/pages/install-client/schemata";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

const InstallClientPageParams = z.object({
  deviceSlug: deviceSlugSchema,
  installationType: installationTypeSchema.optional(),
});

export const Route = createFileRoute(
  "/_authenticated/_layout/_main/_centered/install-client/$deviceSlug/{-$installationType}",
)({
  params: { parse: (params) => InstallClientPageParams.parse(params) },
  component: InstallClientPage,
  beforeLoad: (context) => {
    // we don't maintain client applications / installation instructions for apple-vision-pro yet, just link to external instructions
    if (context.params.deviceSlug === ClientApplicationType.AppleVisionPro) {
      throw redirect({
        href: "https://innoactive.io/install-vision-pro",
      });
    }
  },
});
